import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import AdminHeader from './AdminHeader';

/* Rutas que van dentro del panel: llevan la barra lateral en vez de la
   cabecera publica. */
const APP_ROUTES = [
  '/choose',
  '/dashboard',
  '/notifications',
  '/subscribe',
  '/profile',
  '/template-demo',
  '/discount-codes',
  '/admin',
  '/ai-documents'
];

function DynamicHeader() {
  const location = useLocation();
  const isAppRoute = APP_ROUTES.some((route) => location.pathname.startsWith(route));

  return isAppRoute ? <AdminHeader /> : <Header />;
}

export default DynamicHeader;
